export default __webpack_public_path__ + "static/media/dbs.8c2c130e.jpg";